export default __webpack_public_path__ + "static/south-east-startup-awards-ce479b1df5d386470a0d5a3cf5127079.png";